import { useState } from 'react'

import {
  Row,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  SuccessModal
} from 'components'
import { DeleteIcon, ViewFileIcon } from 'components/Icons'
import { useAuth, useFile } from 'hooks'
import { SPACING } from 'utils'
import FormatarNumeros from 'utils/formatNumbers'
import { ITypeUpload } from 'utils/types'

interface IFakeAttachedFiles {
  tableData?: ITypeUpload[]
  handleDeleteFile?: (_fileName: ITypeUpload) => void
}

const AttachedFiles = ({ tableData, handleDeleteFile }: IFakeAttachedFiles) => {
  const { viewFile } = useFile()

  const [deleteConfirmIsOpen, setDeleteConfirmIsOpen] = useState<boolean>(false)
  const [file, setFileName] = useState<ITypeUpload | null>(null)

  const handleDeleteClick = (fileName: ITypeUpload) => {
    setFileName(fileName)
    setDeleteConfirmIsOpen(true)
  }

  const handleConfirmDelete = () => {
    handleDeleteFile(file)
    setDeleteConfirmIsOpen(false)
  }

  const formatDate = (date: Date) => FormatarNumeros.formatDate(date);
  const returnExistingFormattedDate = (dateString: string) => FormatarNumeros.returnExistingFormattedDate(dateString);

  const currentDate = new Date();
  const matricula = useAuth().usuarioCsn.NmMatricula;

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left" minwidth="300px"> Nome do arquivo</TableCellStyled>
              <TableCellStyled align="left">Descrição / Observação</TableCellStyled>
              <TableCellStyled align="left">Data</TableCellStyled>
              <TableCellStyled align="left">Usuário Matricula</TableCellStyled>
              <TableCellStyled align="center">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.map((row) => (
              <TableRowStyled key={String(row?.documentoExternoGedId)}>
                <TableCellStyled align="left"> {row.dsExtensaoDoc} </TableCellStyled>
                <TableCellStyled align="left"> {row.dsDocumento} </TableCellStyled>
                <TableCellStyled align="left"> {returnExistingFormattedDate(row?.dtAnexo) || formatDate(currentDate)} </TableCellStyled>
                <TableCellStyled align="left"> {row?.usuarioMatricula || matricula} </TableCellStyled>
                <TableCellStyled align="center">
                  <Row alignItems="center" justifyContent="center">
                    <ViewFileIcon
                      cursor="pointer"
                      onClick={() =>
                        viewFile({
                          gedExternalID: row?.documentoExternoGedId,
                          local: {
                            base64: row?.base64,
                            filename: row?.dsDocumento
                          }
                        })
                      }
                      marginRight={SPACING.spacing10}
                    />
                    <DeleteIcon
                      cursor="pointer"
                      onClick={() => handleDeleteClick(row)}
                    />
                  </Row>
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <SuccessModal
        message="Tem certeza de que deseja deletar o arquivo?"
        open={deleteConfirmIsOpen}
        type="alert"
        handleConfirm={handleConfirmDelete}
        handleCancel={() => setDeleteConfirmIsOpen(false)}
        txtButtonConfirm="SIM"
      />
    </>
  )
}

export default AttachedFiles
